import gql from 'graphql-tag';

export const GET_NEWS_QUERY = gql`
    query News($limit: Int, $offset: Int, $genre: [QueryArgument!]) {
        entries: newsEntries(
            limit: $limit,
            offset: $offset,
            genre: $genre,
            orderBy: "postDate desc"
        ) {
            ... on news_Entry {
                id
                url
                title
                postDate
                newsFeaturedImage(limit: 1) @transform(width: 640, height: 480, format: "webp") {
                    url
                    srcset(sizes: ["1x", "2x", "3x"])
                }
            }
        }
    }
`;
